import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "@revvsales/components";
import MetadataSection from "./MetadataSection";
import DocumentReviewSection from "./DocumentReviewSection";

// Action imports
import { updateToolPaneData } from "../../actions/QuotationActions/QuotationActions";
import {
  removeQuickReviewData,
  reverseUpdateComponentQuickReview,
  copyComponentsQuickReview,
} from "../../actions/MetalensActions/metalensActions";

const QuickReview = ({
  updateToolPaneDataAction,
  // toolpaneIsOpen,
  removeQuickReviewDataAction,
  reverseUpdateComponentQuickReviewAction,
  copyComponentsQuickReviewAction,
}) => {
  const quickReviewRef = useRef(null);

  const [activeTab, setActiveTab] = useState("documentReview");

  // const _handleClickOutside = e => {
  //   const node = quickReviewRef.current;
  //   if (
  //     (node && e && node.contains(e.target)) ||
  //     (e &&
  //       e.target &&
  //       e.target.dataset &&
  //       e.target.dataset.belongsto === "metalens-dropdown")
  //   ) {
  //     return;
  //   }
  //   // Close the popup other wise
  //   if (toolpaneIsOpen) {
  //     updateToolPaneDataAction(false, "");
  //   }
  // };

  // useEffect(
  //   () => {
  //     document.addEventListener("click", _handleClickOutside);

  //     return () => document.removeEventListener("click", _handleClickOutside);
  //   },
  //   [_handleClickOutside],
  // );

  useEffect(
    () => {
      copyComponentsQuickReviewAction();

      return () => {
        removeQuickReviewDataAction();
        reverseUpdateComponentQuickReviewAction();
      };
    },
    [
      copyComponentsQuickReviewAction,
      removeQuickReviewDataAction,
      reverseUpdateComponentQuickReviewAction,
    ],
  );

  return (
    <div
      ref={quickReviewRef}
      className="context-quickreview animated fadeinright">
      <div className="metalens-head">
        {/* <span className="metalens-head-icon-microscope">
          <FontAwesomeIcon icon={["fas", "microscope"]} />
        </span> */}
        <span className="metalens-head-title">Metalens</span>
        <Tooltip
          placement="top"
          overlayClassName="metalens-tooltip"
          align={{
            offset: [0, 4],
          }}
          overlay="Metalens identifies and highlights data in the document such as names, dates, amounts, and more">
          <span className="metalens-head-info-circle">
            <FontAwesomeIcon icon={["far", "info-circle"]} className="" />
          </span>
        </Tooltip>
        <span className="metalens-head-close">
          <FontAwesomeIcon
            onClick={() => {
              updateToolPaneDataAction(false, "");
            }}
            onKeyDown={() => {}}
            role="button"
            tabIndex="0"
            icon={["far", "times-circle"]}
            className=""
          />
        </span>
      </div>
      <div className="quickreview-tab">
        <div
          className={`quickreview-tab-switch quickreview-tab-switch-docrev ${
            activeTab === "documentReview" ? "quickreview-tab-active " : ""
          }`}
          onKeyDown={() => {}}
          role="button"
          tabIndex="0"
          onClick={() => setActiveTab("documentReview")}>
          <FontAwesomeIcon
            icon={["far", "glasses"]}
            className="quickreview-tab-icon"
          />
          Document review
          <span className="quick-review-beta-tag">Beta</span>
        </div>
        <div
          className={`quickreview-tab-switch quickreview-tab-switch-meta ${
            activeTab === "documentReview" ? "" : "quickreview-tab-active "
          }`}
          onKeyDown={() => {}}
          role="button"
          tabIndex="0"
          onClick={() => setActiveTab("metadata")}>
          <FontAwesomeIcon
            icon={["far", "address-card"]}
            className="quickreview-tab-icon"
          />
          Metadata
        </div>
      </div>

      {activeTab === "documentReview" ? (
        <DocumentReviewSection />
      ) : (
        <MetadataSection />
      )}
    </div>
  );
};

const mapStateToProps = ({ ToolPaneStore: { isOpen: toolpaneIsOpen } }) => ({
  toolpaneIsOpen,
});

const mapDispatchToProps = {
  updateToolPaneDataAction: updateToolPaneData,
  removeQuickReviewDataAction: removeQuickReviewData,
  reverseUpdateComponentQuickReviewAction: reverseUpdateComponentQuickReview,
  copyComponentsQuickReviewAction: copyComponentsQuickReview,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(QuickReview);



// WEBPACK FOOTER //
// ./src/components/QuickReview/QuickReview.js